<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Store Purchases Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      filterPurchases: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        product: "",
        title: "Store Purchase Report",
        page: 1,
        per_page: 50,
      },
      title: "Store Purchase Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Store Purchases Report",
          active: true,
        },
      ],
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsStorePurchasesReportServerPginated: true,
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "qty",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "unitPrice",
          sortable: true,
          label: "UNIT PRICE",
        },
        {
          key: "total",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "purchase.date",
          sortable: true,
          label: "DATE",
        },
      ],
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("purchase", [
      "SaveStatus",
      "StorePurchasesReport",
      "StorePurchasesReportPagination",
      "StorePurchasesReportPaginated",
      "StorePurchaseReportSummary",
    ]),
    ...mapGetters("setting", ["PaymentOptions"]),
    ...mapGetters("products", ["Products"]),

    rows() {
      return this.IsStorePurchasesReportServerPginated
        ? this.StorePurchasesReportPagination.total
        : this.StorePurchasesReport
        ? this.StorePurchasesReport.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsStorePurchasesReportServerPginated) {
          return (
            this.StorePurchasesReportPagination.per_page ||
            this.filterPurchases.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsStorePurchasesReportServerPginated) {
          this.filterPurchases.per_page = value;
          this.filterPurchases.page = 1; // Reset to first page when changing page size
          this.FetchPurchasesReport(this.filterPurchases);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.StorePurchasesReportPaginated &&
          this.StorePurchasesReportPagination
          ? this.StorePurchasesReportPagination.current_page
          : 1;
      },
      set(value) {
        if (this.StorePurchasesReportPaginated) {
          this.filterPurchases.page = value;
          this.handlePageChange(value);
        }
      },
    },

    totals() {
      return (
        this.StorePurchaseReportSummary || {
          totalAmount: 0,
        }
      );
    },
  },

  methods: {
    ...mapActions({
      FetchPurchasesReport: "purchase/fetchStorePurchasesReport",
      FetchModes: "setting/fetchPaymentOptions",
      FetchProducts: "products/fetchProducts",
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    addCommas() {
      this.edit.paid = this.thousandSeperator(this.edit.paid);
    },

    PurchasesReportData() {
      let payload = { ...this.filterPurchases };

      payload.page = 1;
      // Keep the current per_page value instead of resetting to serverPerPage
      if (!payload.per_page) {
        payload.per_page = this.serverPerPage;
      }

      this.FetchPurchasesReport(payload);
    },

    Excel_export() {
      axios
        .post("export_storepurchases", this.filterPurchases, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "sales_report.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          // this.$toast.add({
          //   severity: "success",
          //   summary: "Successful",
          //   detail: "Sales Report Downloaded successfully",
          //   life: 6000,
          // });
          this.spinner = false;
        })
        .catch(() => {
          // this.spinner = false;
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Something wrong",
          //   detail: "Sales Report Download failed",
          //   life: 6000,
          // });
        });
    },

    handlePageChange(newPage) {
      if (this.IsStorePurchasesReportServerPginated) {
        this.filterPurchases.page = newPage;
        this.FetchPurchasesReport(this.filterPurchases);
      }
    },
  },

  watch: {
    StorePurchasesReport(newValue) {
      if (newValue == true) {
        this.PurchasesReportData();
      }
    },
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  created() {
    this.FetchPurchasesReport(this.filterPurchases);
    this.FetchModes();
    this.FetchProducts();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3
                  class="card-title mb-2 text-center"
                  v-html="filterPurchases.title"
                ></h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-download"></i>Export</b-button
                >
              </div>
              <div class="col-md-3 form-group mb-2">
                <label>FROM</label>
                <input
                  @change="PurchasesReportData()"
                  type="date"
                  v-model="filterPurchases.datefrom"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-3 form-group">
                <label>TO</label>
                <input
                  @change="PurchasesReportData()"
                  v-model="filterPurchases.dateto"
                  type="date"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-2 form-group">
                <label>PRODUCT</label>

                <model-list-select
                  :list="
                    Products
                      ? [{ id: '', name: 'All Products' }, ...Products]
                      : []
                  "
                  v-model="filterPurchases.product"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="PurchasesReportData()"
                >
                </model-list-select>
              </div>
              <div class="col-md-1 mt-4">
                <button
                  class="btn btn-primary cursor-pointer"
                  type="button"
                  @click="PurchasesReportData()"
                >
                  <span class="fa fa-filter cursor-pointer"></span> Filter
                  <b-spinner
                    v-show="SaveStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0 mt-2">
              <DataTable
                :columns="fields"
                :rows="StorePurchasesReport || []"
                :total-rows="rows"
                :pagination="StorePurchasesReportPagination"
                :server-pagination="IsStorePurchasesReportServerPginated"
                :loading="SaveStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(product)="{ row }">
                  {{ row.product }}
                </template>
                <template #cell(qty)="{ row }">
                  {{ row.qty }}
                </template>
                <template #cell(unitPrice)="{ row }">
                  {{ row.unitPrice }}
                </template>
                <template #cell(total)="{ row }">
                  {{ row.total }}
                </template>
                <template #cell(purchase.date)="{ row }">
                  {{ row.purchase.date }}
                </template>
              </DataTable>
              <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-4">
                  <h5>
                    Total Amount:
                    <span class="text-danger">{{
                      thousandSeperator(totals.totalAmount)
                    }}</span>
                  </h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
